export const pct = (n: number) => `${(n * 100).toFixed(1)} %`;

export const when = (t: number | null) =>
  t
    ? new Date(t).toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

/**
 * Error share of a tool: most "errors" are instructions addressed to the agent, so the bar
 * is higher than for the external APIs — a tool failing one call in five is worth a look.
 */
export const errorTone = (rate: number): "default" | "warn" | "bad" =>
  rate >= 0.2 ? "bad" : rate >= 0.05 ? "warn" : "default";

export const toneClass = (tone: "default" | "warn" | "bad") =>
  tone === "bad"
    ? "text-red-600 dark:text-red-400"
    : tone === "warn"
      ? "text-amber-600 dark:text-amber-400"
      : "";
